import * as Sentry from '@sentry/browser'
import {
  CountryService,
  ICountry,
  ProvinceService,
  IProvince,
  DistrictService,
  IDistrict,
  ISubDistrict,
  SubDistrictService,
} from 'features/Address'
import { OptionProps } from 'types'

interface GetCountryResult {
  countries: ICountry[]
  isError: boolean
}

interface GetProvinceResult {
  provinces: IProvince[]
  isError: boolean
}

interface GetDistrictResult {
  districts: IDistrict[]
  isError: boolean
}

interface GetSubDistrictResult {
  subDistricts: ISubDistrict[]
  isError: boolean
}

export const getCountries = async (): Promise<GetCountryResult> => {
  try {
    const { body: countries } = await CountryService.findAll()

    return { countries, isError: false }
  } catch (error) {
    Sentry.captureException(error)

    return { countries: [], isError: true }
  }
}

export const getProvinces = async (
  countryId: string,
): Promise<GetProvinceResult> => {
  try {
    const params = countryId ? { parentId: countryId } : {}
    const { body: provinces } = await ProvinceService.findAll(params)

    return { provinces, isError: false }
  } catch (error) {
    Sentry.captureException(error)

    return { provinces: [], isError: true }
  }
}

export const getDistricts = async (
  provinceId: string,
): Promise<GetDistrictResult> => {
  try {
    const { body: districts } = await DistrictService.findAll({
      parentId: provinceId,
    })

    return { districts, isError: false }
  } catch (error) {
    Sentry.captureException(error)

    return { districts: [], isError: true }
  }
}

export const getSubDistricts = async (
  districtId: string,
): Promise<GetSubDistrictResult> => {
  try {
    const { body: subDistricts } = await SubDistrictService.findAll({
      parentId: districtId,
    })

    return { subDistricts, isError: false }
  } catch (error) {
    Sentry.captureException(error)

    return { subDistricts: [], isError: true }
  }
}

export const handlePostalCode = (
  option: OptionProps,
  subDistricts: ISubDistrict[],
): string => {
  const selectedSubDistrict = subDistricts.find(
    (subDistrict) => subDistrict.id === option.key.id,
  )

  // "0" is not found in address postalCode field.
  if (!selectedSubDistrict || selectedSubDistrict.postalCode === '0') {
    return ''
  }

  return selectedSubDistrict.postalCode
}

export const getErrorMsg = (
  data: string,
  errorText: string | undefined,
  isSameAsCompany?: boolean,
): string | undefined => {
  if (isSameAsCompany) {
    return !data ? errorText : undefined
  }

  return !data ? errorText : undefined
}

export const handleIsError = (
  isSameAsCompany: boolean,
  data: string,
  error: boolean,
): boolean => {
  if (isSameAsCompany) {
    return !data ? error : false
  }

  return !data ? error : false
}
